const uploadFile = (mutate, file, variables) => mutate({
  variables: {
    ...variables,
    file,
  },
});

const processUploadedFiles = (
  mutate,
  files,
  variables,
) => Promise.allSettled(
  files.map((file) => uploadFile(
    mutate,
    file,
    variables,
  )),
);

export default processUploadedFiles;
